module.exports = __webpack_public_path__ + "static/img/cadasto-nova-senha.cd6862a1.svg";